const extrasForm = document.getElementById('extras-form');
const moreBtn = document.getElementById('extras-more-btn');

if (extrasForm) {
  const LINE_ATTR = 'data-extras-line';

  const hiddenField = (name, value) => {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    input.setAttribute(LINE_ATTR, '');
    return input;
  };

  const syncExtras = (form) => {
    if (!form || form.classList.contains('installment') || form.classList.contains('product-upsell__form')) return;
    form.querySelectorAll(`[${LINE_ATTR}]`).forEach((node) => node.remove());
    let index = 1;
    extrasForm.querySelectorAll('input[name="extras[]"]:checked').forEach((input) => {
      form.append(hiddenField(`items[${index}][id]`, input.value));
      form.append(hiddenField(`items[${index}][quantity]`, '1'));
      index++;
    });
  };

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest('[name="add"], [data-add-to-cart], [data-cart-bar-add-to-cart]');
      if (!button) return;
      syncExtras(button.form || button.closest('form') || document.querySelector('button[name="add"]')?.form);
    },
    true
  );
}

if (extrasForm && moreBtn) {
  // Height of the tallest item in the first row, so collapsed state shows exactly one row.
  const rowHeight = () => {
    const columns = getComputedStyle(extrasForm).gridTemplateColumns.split(' ').length;
    const items = extrasForm.children;
    let max = 0;
    for (let i = 0; i < columns && i < items.length; i++) {
      max = Math.max(max, items[i].getBoundingClientRect().height);
    }
    return max;
  };

  const collapse = () => {
    if (extrasForm.classList.contains('expanded')) return;
    const gap = parseInt(getComputedStyle(extrasForm).gap, 10) || 16;
    const oneRow = rowHeight() + gap;
    extrasForm.style.maxHeight = `${oneRow}px`;
    moreBtn.style.display = extrasForm.scrollHeight <= oneRow ? 'none' : 'flex';
  };

  const label = moreBtn.querySelector('.extras-toggle-label');

  moreBtn.addEventListener('click', () => {
    if (extrasForm.classList.contains('expanded')) {
      extrasForm.classList.remove('expanded');
      collapse();
      label.textContent = moreBtn.dataset.labelMore;
    } else {
      extrasForm.classList.add('expanded');
      extrasForm.style.maxHeight = `${extrasForm.scrollHeight}px`;
      label.textContent = moreBtn.dataset.labelLess;
    }
  });

  collapse();

  let resizeTimer;
  window.addEventListener('resize', () => {
    if (extrasForm.classList.contains('expanded')) return;
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(collapse, 150);
  });

  document.addEventListener('shopify:section:load', collapse);
}
